import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { apiClient } from "@/config/api";
import {
  NotificationPreferenceEntry,
  UpdateNotificationPreferenceInput,
} from "./types";

export const getNotificationPreferences = createAsyncThunk<
  NotificationPreferenceEntry[],
  void,
  { rejectValue: string }
>(
  "notificationPreferences/getNotificationPreferences",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get("/profile/notification-preferences");
      return response.data.data.preferences;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message ||
            "Failed to load notification preferences"
        );
      }
      return rejectWithValue("Failed to load notification preferences");
    }
  }
);

export const updateNotificationPreferences = createAsyncThunk<
  NotificationPreferenceEntry[],
  UpdateNotificationPreferenceInput[],
  { rejectValue: string }
>(
  "notificationPreferences/updateNotificationPreferences",
  async (preferences, { rejectWithValue }) => {
    try {
      const response = await apiClient.put(
        "/profile/notification-preferences",
        { preferences }
      );
      return response.data.data.preferences;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message ||
            "Failed to update notification preferences"
        );
      }
      return rejectWithValue("Failed to update notification preferences");
    }
  }
);
